import { conditionFormatter } from "../../core/utils/formatters";

/**
 * A year on a request means "this year or newer", so it reads with a trailing
 * `+`. The current year has nothing newer to stand for, so it reads plain.
 *
 * Mirrors LookbookService::displayYear on the backend — the PDF is rendered
 * there, this is the on-screen preview of the same line. Keep them in step.
 */
export function requestYearLabel(year) {
  const value = String(year ?? "").trim();

  if (!value) return null;
  if (!/^\d+$/.test(value)) return value;

  return Number(value) >= new Date().getFullYear() ? value : `${value}+`;
}

/**
 * The line under the model in the lookbook grid:
 * "<reference> / <year> / <condition>". Empty parts drop out rather than
 * leaving a dangling separator.
 */
export function requestMetaLine(request) {
  return [
    request?.product?.reference_number,
    requestYearLabel(request?.year),
    conditionFormatter(request?.condition),
  ]
    .filter((part) => part !== null && part !== undefined && part !== "")
    .join(" / ");
}
